import React, { useEffect, useRef } from 'react';
import './CheckMarkBoxDialog.css';
import Button from '@mui/material/Button';
import { getLanguageTexts } from '@sharedInterfaces/Language/languageHelper';
import CheckMarkBox from '@src/App/Components/General/CheckMarkBox/CheckMarkBox';
import type { AppState } from '@store/store';
import { useSelector } from 'react-redux';

interface CheckMarkBoxDialogProps {
    text?: string;
    onClose: () => void;
}

function CheckMarkBoxDialog(props: CheckMarkBoxDialogProps) {
    const lang = useSelector((state: AppState) => state.employee.language);
    const close = getLanguageTexts(lang).skills.oftenUsed.close;

    const dialogRef = useRef<HTMLDialogElement>(null);
    const timerRef = useRef<number | null>(null);

    useEffect(() => {
        if (dialogRef.current) {
            dialogRef.current.showModal();

            // Automatisches Schließen nach 3500ms
            timerRef.current = window.setTimeout(() => {
                if (dialogRef.current && dialogRef.current.open) {
                    dialogRef.current.close();
                }
            }, 3500);

            // Timer abbrechen und onClose aufrufen, wenn der Dialog geschlossen wird
            const handleClose = () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                    timerRef.current = null;
                }
                props.onClose();
            };

            dialogRef.current.addEventListener('close', handleClose);

            return () => {
                if (timerRef.current) {
                    clearTimeout(timerRef.current);
                }
                dialogRef.current?.removeEventListener('close', handleClose);
            };
        }
    }, [props]);

    return (
        <dialog ref={dialogRef} className="checkMarkBoxDialog">
            <div className="dialogContent">
                <CheckMarkBox text={props.text} />
            </div>
            <div className="dialogActions">
                <Button
                    variant="contained"
                    color="primary"
                    style={{ float: 'right' }}
                    onClick={() => dialogRef.current?.close()}
                >
                    {close}
                </Button>
            </div>
        </dialog>
    );
}

export default CheckMarkBoxDialog;
